import { getSettingsAll } from "api"
import { useEffect, useState } from "react"

const useSettingValue = (key: string): string | null => {
  const [value, setValue] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const fetchSetting = async () => {
      try {
        const response = await getSettingsAll()
        if (cancelled) return
        const setting = response.data.body?.find((s) => s.key === key)
        const trimmed = setting?.value?.trim()
        setValue(trimmed ? trimmed : null)
      } catch (error) {
        if (cancelled) return
        console.error(`Failed to fetch setting "${key}":`, error)
        setValue(null)
      }
    }
    fetchSetting()
    return () => {
      cancelled = true
    }
  }, [key])

  return value
}

export default useSettingValue
